import { ColorBlock } from "@/components/page";
import { useResourceList } from "@/components/data";

type ClinicDoc = {
  id: number;
  doc_name: string;
  description: string | null;
  doc_date: string | null;
};

const dateFmt = new Intl.DateTimeFormat("he-IL", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

export function ClinicDocumentsPage() {
  const { data, isLoading } = useResourceList<ClinicDoc>("clinic_documents");
  const items = data ?? [];

  return (
    <div className="space-y-6 sm:space-y-7">
        <header className="pb-2">
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-stone-500">
            מסמכי קליניקה
          </p>
          <h1 className="mt-3 flex items-baseline gap-3 text-2xl sm:text-3xl font-bold tracking-tight text-stone-900">
            <span className="tabular-nums" dir="ltr">{items.length}</span>
            <span className="text-stone-300 text-lg sm:text-xl">·</span>
            <span className="text-stone-700 text-lg sm:text-xl">מסמכים</span>
          </h1>
          <p className="mt-3 max-w-xl text-sm sm:text-base text-stone-600 leading-snug">
            דרישות תשלום, מכתבי המלצה, חומרים מקצועיים.
          </p>
        </header>

        {isLoading ? (
          <p className="text-sm text-stone-500">טוען…</p>
        ) : items.length === 0 ? (
          <ColorBlock tint="cream" className="text-center" size="lg">
            <p className="text-base sm:text-lg font-bold tracking-tight text-stone-900">אין מסמכים.</p>
          </ColorBlock>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {items.map((d) => (
              <div key={d.id} className="rounded-2xl bg-white px-6 py-5">
                <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-stone-500" dir="ltr" style={{ direction: "rtl" }}>
                  {d.doc_date ? dateFmt.format(new Date(d.doc_date)) : "ללא תאריך"}
                </div>
                <h2 className="mt-2 text-lg font-semibold tracking-tight text-stone-900 leading-snug">
                  {d.doc_name}
                </h2>
                {d.description && (
                  <p className="mt-3 text-sm text-stone-600 leading-relaxed">{d.description}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
  );
}
